<template>
    <section>
        <v-container class="nav">
            <v-btn icon class="black--text" @click="$router.go(-1)">
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiDoctor }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Maximum Benefit Limit
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App Bar -->
        <v-container style="width:90%; margin:auto">
            <div v-if="getMBL">
                <div style="background-color: white; padding: 3px; border-radius: 5px;">
                    <v-alert
                        color="teal darken-3"
                        outlined
                        style="margin: 0;"
                        type="info"
                    >
                        <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                    </v-alert>
                </div>
                <br>
                <v-data-table
                    :headers="headers"
                    :items="getData"
                    no-data-text
                    :footer-props="footer_props"
                    class="my-10 elevation-10"
                >
                    <template #item="{ item }">
                        <tr v-if="screen_width < 600" class="mbl_tbl">
                            <td>
                                <ul>
                                    <li>Limit<span>{{ item.LIMIT }}</span></li>
                                    <li>Used<span>{{ item.USED }}</span></li>
                                    <li>Has Available?<span>{{ item.HAS_AVAILABLE }}</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr v-else>
                            <td v-text="item.LIMIT"></td>
                            <td v-text="item.USED"></td>
                            <td v-text="item.HAS_AVAILABLE"></td>
                        </tr>
                    </template>
                </v-data-table>

                <!--
				<template slot="item" slot-scope="props">
					<tr>
						<td v-text="props.item.LIMIT" />
						<td v-text="props.item.USED" />
						<td v-text="props.item.HAS_AVAILABLE" />
					</tr>
				</template>
				-->
            </div>
        </v-container>
    </section>
</template>

<script>
import { mdiArrowLeft, mdiDoctor } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'

export default {
    data: () => {
        return({
            mdiArrowLeft, mdiDoctor,
            screen_width: document.documentElement.clientWidth + 9,
            AR: null,
            footer_props: {
                'items-per-page-options': []
            },
            headers: [
                {
                    text: 'Max. Benefit Limit',
                    align: 'left',
                    value: 'LIMIT',
                    class: 'teal--text'
                },
                {
                    text: 'Used Benefits',
                    align: 'left',
                    value: 'USED',
                    class: 'teal--text'
                },
                {
                    text: 'Has Available?',
                    align: 'left',
                    value: 'HAS_AVAILABLE',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        ...mapGetters(['getMBL']),
        getData: {
            get(){
                const obj = [{
                    LIMIT: this.getMBL.LIMIT,
                    USED: this.getMBL.USED,
                    HAS_AVAILABLE: this.getMBL.HAS_AVAILABLE ? 'YES' : 'NO'
                }]
                return obj
            }
        }
    },
    mounted () {
        window.addEventListener('resize', this.onResize)
        this.displayMBL({ MEMBN: this.$cookies.get('usermembn') })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['displayMBL', 'getCsrfToken']),
        print(param) {
            // console.log(param);
            return param
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 8
        }
    }
}
</script>

<style scoped>
section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

.mbl_tbl {
	/* background-color: red; */
	width: 100%;
}

.mbl_tbl td {
	/* background-color: blue; */
	width: 600px;
}

.mbl_tbl td ul {
	/* background-color: green; */
	margin-left: 0;
	padding-left: 0;
	list-style: none;
}

.mbl_tbl td ul li {
	margin: 10px 0;
	padding: 10px 0;
	text-align: left;
	/* background-color: brown; */
	position: relative;
	font-weight: bold;
}

.mbl_tbl td ul li span {
	text-align: right;
	font-weight: 400;
	/* background-color: pink; */
	position: absolute;
	right: 0;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
